import { createContext, useContext, useMemo, useState } from "react";
import ErrorDialog from "../Reuse/UI/Dialog/ErrorDialog";
import InfoDialog from "../Reuse/UI/Dialog/InfoDialog";
import ConfirmDialog from "../Reuse/UI/Dialog/ConfirmDialog";

const DialogContext = createContext();

export const DialogProvider = ({ children }) => {
  const [error, setError] = useState(null);
  const [info, setInfo] = useState(null);
  const [confirm, setConfirm] = useState(null);

  // call this function when you want to authenticate the user
  const showConfirm = (message=null,note=null, close = null) => {
    const data = {
      message,
      note,
      close,
    };
    setConfirm(data);
  };
  const hideConfirm = () => {
    setConfirm(null);
  };
  // call this function when you want to authenticate the user
  const showError = (message, close = null) => {
    const data = {
      message,
      close,
    };
    setError(data);
  };
  const hideError = () => {
    setError(null);
  };
  // call this function when you want to authenticate the user
  const showInfo = (message, close = null) => {
    setInfo({
      message,
      close,
    });
  };
  const hideInfo = () => {
    setInfo(null);
  };

  const value = useMemo(
    () => ({
      showError,
      hideError,
      error,
      showInfo,
      hideInfo,
      info,
      confirm,
      showConfirm,
      hideConfirm
    }),
    [error, info, confirm]
  );
  return (
    <DialogContext.Provider value={value}>
      <ErrorDialog />
      <InfoDialog />
      <ConfirmDialog />
      {children}
    </DialogContext.Provider>
  );
};

export const useDialog = () => {
  return useContext(DialogContext);
};
